import warningNovis from '~/assets/dispatch/icons/Type=OmissionWarning.svg';
import warningPause from '~/assets/dispatch/icons/Type=PauseWarning.svg';
import warningQuestion from '~/assets/dispatch/icons/Type=QuestionWarning.svg';
import warningSleep from '~/assets/dispatch/icons/Type=SleepWarning.svg';
import warningSpeed from '~/assets/dispatch/icons/Type=SpeedWarning.svg';
import warningSteering from '~/assets/dispatch/icons/Type=SteeringWarning.svg';
import warningTime from '~/assets/dispatch/icons/Type=Waiting.svg';
import warningTools from '~/assets/dispatch/icons/Type=CorrectiveMaintenance.svg';
import warningAttention from '~/assets/dispatch/icons/Warning_Icon.svg';

export const WARNING_IMAGE_MAPPER = {
  noVisibility: warningNovis,
  pause: warningPause,
  question: warningQuestion,
  sleep: warningSleep,
  speed: warningSpeed,
  steering: warningSteering,
  time: warningTime,
  maintenance: warningTools,
  attention: warningAttention,
  attentionAnomaly: warningAttention,
};

export const jsonToImageMapper = [
  {
    id_code: 0,
    warningTools: WARNING_IMAGE_MAPPER.maintenance,
  },
  {
    id_code: 1,
    warningPause: WARNING_IMAGE_MAPPER.pause,
  },
  {
    id_code: 2,
    warningAnomaly: null,
  },
  {
    id_code: 3,
    warningPause: WARNING_IMAGE_MAPPER.pause,
  },
  {
    id_code: 4,
    warningPause: WARNING_IMAGE_MAPPER.pause,
  },
];
